export const comprometimentoSituacao = {
    SEM_COMPROMETIMENTO: 0,
    NAO_COMPROMETIDO: 1,
    COMPROMETIMENTO_ENVIADO: 2,
    COMPROMETIMENTO_COM_PENDENCIA: 3,
    COMPROMETIDO_COM_SUCESSO: 4,
    VINCULADO_A_UM_PAGAMENTO: 5,
    SEM_COMPROMETIMENTO2: 6,
    BLOQUEADO: 7
}
